__turbopack_context__.v({
  "disabled": "Label-module__B4MKaa__disabled",
  "label": "Label-module__B4MKaa__label",
  "required": "Label-module__B4MKaa__required",
});
